import type {SvgIconProps} from '@mui/material';
import {SvgIcon} from '@mui/material';
import {memo} from 'react';

export const AwsSqs = memo((props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 256 309"
      preserveAspectRatio="xMidYMid"
      fill="currentColor"
      {...props}
    >
      <g>
        <path
          d="M255.991,100.211 L251.879,100.142 L128.087,63.492 L128.013,61.796 L128.013,0 L256,64.006 L255.991,100.211"
          fill="#D9A741"
        ></path>
        <path
          d="M128,65.5 L128.013,0 L0.017,63.981 L0,244.996 L0.064,245.028 L0.064,245.03 L127.987,309.003 L128.412,308.412 L128.247,247.541 L127.996,247.202 L120,241.5 L21,212 L21.5,97.5 L128,65.5"
          fill="#876929"
        ></path>
        <path
          d="M147.141,195.298 L16.351,213.697 L16.36,95.28 L147.15,113.704 L147.141,195.298"
          fill="#D9A741"
        ></path>
        <path
          d="M80.864,187.813 L127.996,193.813 L128.004,115.155 L80.873,121.15 L80.864,187.813"
          fill="#876929"
        ></path>
        <path
          d="M33.385,181.771 L63.972,185.659 L63.981,123.296 L33.385,127.193 L33.385,181.771"
          fill="#876929"
        ></path>
        <path
          d="M16.36,95.28 L128.013,61.796 L255.991,100.211 L147.231,113.713 L16.36,95.28"
          fill="#624A1E"
        ></path>
        <path
          d="M255.927,177.376 L127.996,193.521 L128.004,115.155 L255.927,131.451 L255.927,177.376"
          fill="#D9A741"
        ></path>
        <path
          d="M255.918,208.834 L253.165,208.953 L128.389,246.723 L127.996,247.202 L127.987,309.003 L255.918,245.052 L255.918,208.834"
          fill="#D9A741"
        ></path>
        <path
          d="M16.351,213.697 L127.996,247.202 L255.918,208.834 L147.141,195.298 L16.351,213.697"
          fill="#FAD791"
        ></path>
      </g>
    </SvgIcon>
  );
});
AwsSqs.displayName = 'AwsSqs';
